import actionTypes from 'SRC/modules/redux/actionTypes'

export const setProfilePage = (page) => ({
  type: actionTypes.SET_PROFILE_PAGE,
  payload: page
})
